/*eslint-disable */

import {
  bus
} from '@/main';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery');
export default {
  name: 'unsubscribe',
  components: {},
  props: [],
  data () {
    return {
      unsubscribeForm:true,
      unsubscribeSuccess:false,
      confirmUnsubscribePopup:false,
      submitted:false
    }
  },
  computed: {

  },
  mounted () {
    bus.$emit('showHeaderbtn', false);
  },
  methods: {
    openUnsubscribePopupMethod(){
      this.unsubscribeForm = false
      this.unsubscribeSuccess = true
    },
    closedUnsubscribePopupMethod(){
      this.unsubscribeForm = true
      this.unsubscribeSuccess = false
    },
    unsubscribeSuccessFun(){
      this.submitted = true
      this.$store.dispatch('unsbcrbUserFun', {id:this.$route.params.unsubscribeID}).then((res)=>{
        this.submitted = false
        this.unsubscribeForm = false
        this.unsubscribeSuccess = false
        this.confirmUnsubscribePopup =  true
      }).catch((err)=>{
        toast.error(err.data.msg);
        this.submitted = false
      })
    },
    redirctedHomePage(){
      window.location.href = '/';
    }
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
  },
  beforeRouteLeave: function(to, from, next) {
    this.stopSound()
    $('body').removeClass('dashboard')
    next();
  },
}


